//import React, { Component } from "react";
import React, { Fragment, useState, useEffect } from "react";
import styled, { createGlobalStyle } from "styled-components";
import ReactDOM from "react-dom";
// we need to get into git
import { useRanger } from "react-ranger";

export const Tick = styled("div")`
  :before {
    content: "";
    position: absolute;
    left: 0;
    background: rgba(0, 0, 0, 0.2);
    height: 5px;
    width: 2px;
    transform: translate(-50%, 0.7rem);
  }
`;
export const Track = styled("div")`
  display: inline-block;
  height: 12px;
  width: 90%;
  margin: 0 5%;
`;

//color: rgba(255, 255, 255, 0.5);
export const TickLabel = styled("div")`
  position: absolute;
  font-size: 0.6rem;
  color: ${props => props.ticklabelcolor};
 // color: yellow;
  top: 100%;
  transform: translate(-50%, 1.2rem);
  white-space: nowrap;
`;

export const Segment = styled("div")`
  background: ${props =>
    props.index === 0
      ? "#3e8aff"
      : props.index === 1
        ? "#00d5c0"
        : props.index === 2
          ? "#f5c200"
          : "#ff6050"};
  height: 100%;
`;


export const Handle = styled("div")`
  background: #ff1a6b;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 100%;
  font-size: 0.7rem;
  white-space: nowrap;
  color: white;
  font-weight: ${props => (props.active ? "bold" : "normal")};
  
`;




//transform: ${props =>
////props.active ? "translateY(-100%) scale(1.3)" : "translateY(0) scale(0.9)"};
//transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);

const DateSlider = (props) => {
  // console.log('DS', props);
  let min = 0;
  let max = 8;
  let stepsize = 1;
  let ticksize = 4;



  let tlc = props.ticklabelcolor;


  const [values, setValues] = React.useState([min, max]);


  const { getTrackProps, ticks, segments, handles } = useRanger({
    min: 0,
    max: 20,
    // min: 0, //props.data.range[0],
    max: props.range[1],

    // stepSize: 2,
    //tickSize: 10,
    stepSize: stepsize,
    tickSize: ticksize,
    values,
    onChange: setValues,
    onDrag: setValues
    //steps: [0, 20000, 100000, 250000, 500000],
    //ticks: [0, 100000, 250000, 500000]
  });




  useEffect(() => {


  }, []);

  useEffect(() => {
    //  console.log('DoubleSlider useEffect detecting a values change', values);
    props.change(values);
  }, [values]);

  useEffect(() => {
    // console.log('DoubleSlider detecting a props.valary change', props.valary);
    // props.data.change(values);
    if (props.valary) {
      // setValues([props.valary[0], props.valary[1]]);
    }

  }, [props.valary]);


  return (
    <div>


      <Track {...getTrackProps()}>
        {ticks.map(({ value, getTickProps }) => (
          <Tick {...getTickProps()}>
            <TickLabel ticklabelcolor={tlc}>{value}</TickLabel>
          </Tick>
        ))}
        {segments.map(({ getSegmentProps }, i) => (
          <Segment {...getSegmentProps()} index={i} />
        ))}
        {handles.map(({ value, active, getHandleProps }) => (
          <button
            {...getHandleProps({
              style: {
                appearance: "none",
                border: "none",
                background: "transparent",
                outline: "none"
              }
            })}
          >
            <Handle active={active}>{value}</Handle>
          </button>
        ))}
      </Track>
      <br />
      <br />


    </div>
  );

}


export default DateSlider;

//export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/deals/DateSlider.js